<template>
  <div>

    <b-breadcrumb>
      <b-breadcrumb-item>Administratie</b-breadcrumb-item>
      <b-breadcrumb-item to="/main/admin/contracts">Contracten</b-breadcrumb-item>
      <b-breadcrumb-item active v-if="editMode">{{name}} bewerken</b-breadcrumb-item>
      <b-breadcrumb-item active v-else>Toevoegen</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="d-flex align-items-center justify-content-between" v-if="editMode">
      <h2>Contract bewerken</h2>
      <b-btn variant="primary" @click="save" :disabled="!dirty"><span class="mdi mdi-content-save"/> Opslaan</b-btn>
    </div>
    <div class="d-flex align-items-center justify-content-between" v-else>
      <h2>Contract toevoegen</h2>
      <busy-btn :busy="addBusy" variant="primary" @click="add">Toevoegen</busy-btn>
    </div>


    <b-form @input="formInput">

      <div class="form-group row" v-if="editMode">
        <label class="col-sm-2 font-weight-bold d-flex align-items-center">Bedrijfsnaam</label>
        <div class="col-sm-4 d-flex align-items-center">
          {{customerName}}
        </div>
      </div>
      <div class="form-group row" v-else>
        <label class="col-sm-2 font-weight-bold d-flex align-items-center">Bedrijfsnaam</label>
        <div class="col-sm-4 d-flex align-items-center">
          <b-input class="d-inline-block" style="width: 15em" @keydown.enter="searchCompanies" v-model="searchCompany" />
          <busy-btn class="d-inline-block ml-2" @click="searchCompanies" :busy="searchBusy">Zoeken</busy-btn>
          <b-select class="ml-2" style="width: 15em" :options="companyOptions" v-model="customerLocalId" />
        </div>
      </div>

    <div class="form-group row d-flex align-items-center">
      <label class="col-sm-2">Contract beëindigen?</label>
      <div class="col-sm-1">
        <b-form-checkbox :value="true" :unchecked-value="false" v-model="terminated">Ja</b-form-checkbox>
      </div>
      <label class="col-sm-2 font-weight-bold">Einddatum</label>
      <div class="col-sm-3">
        <b-form-datepicker :disabled="!terminated" v-model="terminatedOnDate"/>
      </div>

    </div>


  <div class="form-group row">

    <label class="col-sm-2">Contract naam</label>
    <div class="col-sm-3">
      <b-input type="text" v-model="name" />
    </div>

    <label class="col-sm-2 ">Regularisatie?</label>
    <div class="col-sm-1">
      <b-form-checkbox :value="true" :unchecked-value="false" v-model="regularisation">Ja</b-form-checkbox>
    </div>

    <label class="col-sm-2 ">Renting?</label>
    <div class="col-sm-1">
      <b-form-checkbox :value="true" :unchecked-value="false" v-model="renting">Ja</b-form-checkbox>
    </div>

  </div>

  <div class="form-group row">
    <label class="col-sm-2 ">Startdatum</label>
    <div class="col-sm-3">
      <b-form-datepicker v-model="startDate"/>
    </div>
    <label class="col-sm-2 ">Prijsindexatie?</label>
    <div class="col-sm-1">
      <b-form-checkbox :value="true" :unchecked-value="false" v-model="indexation">Ja</b-form-checkbox>
    </div>
  </div>


  <div class="row">

    <div class="col-sm-2 ">
      Printers
    </div>

    <div class="col-sm-9">
      <table class="table table-bordered table-sm printer-input">
        <thead>
        <tr>
          <th>Model</th>
          <th>Merk</th>
          <th>Naam</th>
          <th>Serienummer</th>
          <th>Locatie</th>
          <th>Acties</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(p, idx) in contractPrinters" :key="`p_${idx}`">
          <td style="border-collapse: separate;">
            <treeselect
              name="demo"
              :options="brands.nodes"
              disableBranchNodes
              showCount
              v-model="p.model"
              :clearable="false"
              @select="arg => modelSelected(arg, p, idx)"
            />
          </td>
          <td><b-input type="text" v-model="p.brand" /></td>
          <td><b-input type="text" v-model="p.name" /></td>
          <td><b-input type="text" v-model="p.serial" /></td>
          <td><b-input type="text" v-model="p.location" /></td>
          <td style="text-align: right">
            <b-btn variant="outline-danger" @click="removePrinter(p, idx)">
              <span class="mdi mdi-minus"/>
            </b-btn>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="6" class="text-center">
            <b-btn variant="outline-primary" size="sm" @click="() => addPrinter()"><span class="mdi mdi-plus-thick"/> Printer toevoegen</b-btn>
            <b-btn variant="outline-primary" size="sm" class="ml-1" v-b-modal.search-printer>
              <span class="mdi mdi-search-web"/> Printer zoeken
            </b-btn>
          </td>
        </tr>
        </tfoot>

      </table>
    </div>

  </div>

  <div class="row">
    <div class="col-sm-2 ">Tupels</div>
    <div class="col-sm-9">
      <table class="table table-bordered table-sm tuple-input">
        <thead>
        <tr>
          <th>Tellergroep</th>
          <th>Forfait aantal afdrukken per kwartaal</th>
          <th>Forfait prijs</th>
          <th>Supplementele afdrukken prijs per eenheid</th>
          <th>Weergavenaam</th>
          <th>Acties</th>
        </tr>
        </thead>
        <tbody v-for="(tuple, idx) in tuples" :key="`tuple_${idx}`">
        <tr>
          <td>
            <b-select :options="cgroups.nodes" value-field="id" text-field="displayName" v-model="tuple.cgroup">
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>-- Selecteer --</b-form-select-option>
              </template>
            </b-select>
          </td>
          <td><b-input type="number" v-model="tuple.forfaitNumPrints" number /></td>
          <td>
            <b-input-group prepend="€">
              <b-input type="number" v-model="tuple.forfaitPrice" step="0.0001" />
            </b-input-group>
          </td>
          <td>
            <b-input-group prepend="€">
              <b-input type="number" v-model="tuple.supplPricePerUnit" step="0.0001" />
            </b-input-group>
          </td>
          <td>
            <b-input type="text" v-model="tuple.displayName" />
          <td style="text-align: right">
            <b-btn variant="outline-danger" @click="removeTuple(tuple, idx)">
              <i class="mdi mdi-minus"/>
            </b-btn>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <div class="col-sm-3">Van toepassing op:</div>
            <div class="col-sm-9">
              <b-form-checkbox-group value-field="serial" text-field="serial" v-model="tuple.printerSerials" :options="contractPrinters" />
            </div>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="6" style="text-align: center;">
            <b-btn variant="outline-primary" size="sm" @click="addTuple"><span class="mdi mdi-plus-thick" /> Tupel toevoegen</b-btn>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>

    </b-form>

    <b-modal title="Printer zoeken" lazy id="search-printer" centered size="lg" ok-title="Sluiten" ok-only>
      <div style="height: 32em">
        <search-printer>
          <template #cell(select)="row">
            <span v-if="added[row.item.serial]" style="width: 7em" class="d-inline-block">
              <span class="mdi mdi-check"/> Toegevoegd
            </span>
            <span v-else style="width: 7em" class="d-inline-block">
              <b-link @click="addPrinterFromSearch(row.item)"><span class="mdi mdi-plus" /> Toevoegen</b-link>
            </span>
          </template>
        </search-printer>
      </div>
    </b-modal>

  </div>
  
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import dateComputed from '../../lib/dateComputed';
import {CACHE_AND_NETWORK, NETWORK_ONLY} from '@/lib/constants';
import SearchPrinter from '../../components/SearchPrinter';
import BusyBtn from '@/components/BusyBtn';



function mapPrinter({id, brand, location, name, printer})
{
    return {
        id,
        brand,
        location,
        serial: printer.serial,
        model: printer.model.id,
        name
    }
}

function mapTuple(node)
{
    return {
        cgroup: node.cgroup.id,
        displayName: node.displayName,
        forfaitNumPrints: node.forfaitNumPrints,
        forfaitPrice: node.forfaitPrice,
        id: node.id,
        printerSerials: node.tupleContractPrinters.nodes.map(({contractPrinter}) => contractPrinter.printer.serial),
        supplPricePerUnit: node.supplPricePerUnit,
    }
}


export default
{
    apollo:
    {
        brands:
        {
            query: require('../../graphql/query/models_dropdown.gql')
        },
        cgroups:
        {
            query: require('../../graphql/cgroups.query.gql'),
            fetchPolicy: CACHE_AND_NETWORK
        }
    },
    async mounted()
    {
        if(this.editMode)
        {
            const { data: { contractById } } = await this.$apollo.query(
                {
                    query: require('../../graphql/for_edit_contract.gql'),
                    variables: { id: this.id },
                    fetchPolicy: NETWORK_ONLY
                }
            );

            this.customerName     = contractById.customer.name;
            this.name             = contractById.name;
            this.regularisation   = contractById.regularisation;
            this.renting          = contractById.renting;
            this.start            = contractById.start;
            this.terminated       = contractById.terminated;
            this.terminatedOn     = contractById.terminatedOn;
            this.contractPrinters = contractById.contractPrinters.nodes.map(mapPrinter);
            this.tuples           = contractById.tuples.nodes.map(mapTuple);
            this.indexation       = contractById.indexation;
        }
    },
    components: {BusyBtn, SearchPrinter, Treeselect },
    computed:
    {
        terminatedOnDate: dateComputed('terminatedOn'),
        startDate: dateComputed('start'),
        added()
        {
            let res = {};
            this.contractPrinters.forEach(({serial}) => res[serial] = true);
            return res;
        }
    },
    data()
    {
        return {
            addBusy: false,
            brands: { nodes: [] },
            cgroups: { nodes: [] },
            dirty: false,
            editMode: !!this.id,
            companyOptions: [],
            searchCompany: '',
            customerLocalId: null,
            customerName: '',
            searchBusy: false,
            // Object fields
            contractPrinters: [],
            name: '',
            regularisation: false,
            renting: false,
            start: new Date().getTime(),
            terminated: false,
            terminatedOn: null,
            tuples: [],
            indexation: true
        }
    },
    methods:
    {
        async add()
        {
            this.addBusy = true;

            try
            {
                const customer = this.companyOptions.find(({value}) => value === this.customerLocalId);

                const {data} = await this.$apollo.mutate(
                    {
                        mutation: require('../../graphql/mutation/addContract.gql'),
                        variables:
                        {
                            input:
                            {
                                contractPrinters: this.contractPrinters,
                                customerName: customer.text,
                                customerLocalId: this.customerLocalId,
                                customerSourceUrl: customer.sourceUrl,
                                indexation: this.indexation,
                                name: this.name,
                                regularisation: this.regularisation,
                                renting: this.renting,
                                start: this.start,
                                terminated: this.terminated,
                                terminatedOn: this.terminated ? this.terminatedOn : null,
                                tuples: this.tuples
                            }
                        }
                    }
                );

                await this.$router.replace(`/main/admin/contracts/view/${data.addContract.contract.id}`);
            }
            finally
            {
                this.addBusy = false;
            }
        },
        async save()
        {
            const input =
            {
                id: this.id,
                patch:
                {
                    contractPrinters: this.contractPrinters,
                    indexation: this.indexation,
                    name: this.name,
                    regularisation: this.regularisation,
                    renting: this.renting,
                    start: this.start,
                    terminated: this.terminated,
                    terminatedOn: this.terminated ? this.terminatedOn : null,
                    tuples: this.tuples
                }
            };

            try
            {
                await this.$apollo.mutate(
                    {
                        mutation: require('../../graphql/mutation/edit_contract.gql'),
                        variables: { input }
                    }
                );

                this.dirty = false;
            }
            finally
            {
                this.saveBusy = false;
            }
        },
        addPrinterFromSearch(row)
        {
            const f = this.contractPrinters.find(printer => row.serial === printer.serial);

            if(f === undefined)
                this.addPrinter(row);
        },
        addPrinter(existing = {model:{id: null, brand:{name: ''}, name: ''}, serial: '', location: ''})
        {
            this.contractPrinters.push(
                {
                    brand: existing.model.brand.name || '',
                    serial: existing.serial || '',
                    name: existing.model.name || '',
                    location: existing.location || '',
                    model: existing.model.id
                }
            );
        },
        addTuple()
        {
            this.tuples.push(
                {
                    cgroup: null,
                    forfaitNumPrints: 0,
                    forfaitPrice: '0',
                    printerSerials: [],
                    supplPricePerUnit: '0',
                    displayName: ''
                }
            );
        },
        async searchCompanies()
        {
            this.searchBusy = true;

            try
            {
                console.log('search company');
                const { data } = await this.$apollo.mutate(
                    {
                        mutation: require('../../graphql/mutation/searchCompany.query.gql'),
                        variables:
                        {
                            pageNum: 1,
                            pageSize: 10,
                            term: this.searchCompany
                        }
                    }
                );

                this.companyOptions = data.searchCompanies;
            }
            finally
            {
                this.searchBusy = false;
            }
        },
        removePrinter(printer, idx)
        {
            const [{serial}] = this.contractPrinters.splice(idx, 1);

            this.tuples.forEach(tuple =>
                tuple.printerSerials = tuple.printerSerials.filter(s => s !== serial)
            );
        },
        removeTuple(tuple, idx) { this.tuples.splice(idx, 1); },
        modelSelected(arg, p, idx)
        {
            console.log(arg, p, idx);

            if(p.name === '') p.name = arg.label;
            if(p.brand === '') p.brand = arg.brand.name;
        },
        formInput() { this.dirty = true; }
    },
    props:
    {
        id: { }
    },
    watch:
    {
        contractPrinters() { this.dirty = true },
        tuples() { this.dirty = true },
        start() { this.dirty = true }
    },
    breadcrumb:
    [
        {text: 'Administratie'},
        {text: 'Contracten', to: '/admin/contracts'},
        {text: 'Contract toevoegen'}
    ],
}
</script>

<style>

  table.printer-input th:nth-child(1) { width: 30%; }
  table.printer-input th:nth-child(2) { width: 10%; }
  table.printer-input th:nth-child(3) { width: 20%; }
  table.printer-input th:nth-child(4) { width: 20%; }
  table.printer-input th:nth-child(5) { width: 20%; }
  table.printer-input th:nth-child(6) { width: 1em; }

  table.tuple-input { table-layout: fixed; }
  table.tuple-input th:nth-child(1) { width: 11em; }
  table.tuple-input th:nth-child(2) { width: 25%; }
  table.tuple-input th:nth-child(3) { width: 23%; }
  table.tuple-input th:nth-child(4) { width: 30%; }
  table.tuple-input th:nth-child(5) { width: 22%; }
  table.tuple-input th:nth-child(6) { width: 48px; }

</style>